import React, { useState } from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom"; 
import NavTitle from "./NavTitle";

const Brand = () => {
  const [showBrands, setShowBrands] = useState(true);
  const brands = [
    {
      _id: 9006,
      title: "Fans",
      link: "/products/fans", 
    },
    {
      _id: 9007,
      title: "AC",
      link: "/products/ac", 
    },
    {
      _id: 9008,
      title: "Geyser",
      link: "/products/geyser", 
    },
    {
      _id: 9009,
      title: "Refrigerator",
      link: "/products/refrigerator", 
    },
    {
      _id: 9010,
      title: "Dispenser",
      link: "/products/dispenser", 
    },
    {
      _id: 9010,
      title: "All Products",
      link: "/shop", 
    },
  ];

  return (
    <div>
      <div
        onClick={() => setShowBrands(!showBrands)}
        className="cursor-pointer"
      >
        <NavTitle title="Shop by Brand" icons={true} />
      </div>
      {showBrands && (
        <motion.div
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <ul className="flex flex-col gap-4 text-sm lg:text-base text-[#767676]">
            {brands.map((item) => (
              <li key={item._id} className="border-b-[1px] border-b-[#F0F0F0] pb-2 flex items-center gap-2">
                <NavLink
                  to={item.link} 
                  className="hover:text-primeColor hover:border-gray-400 duration-300 w-full" // Full width for the list item
                >
                  {item.title}
                </NavLink>
              </li>
            ))}
          </ul>
        </motion.div>
      )}
    </div>
  );
};

export default Brand;
